import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, Shield, Cookie } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_90b4c8a6-2372-4e9e-bd52-ac51039d9d6b/artifacts/l6uwsqcm_logo_bravo_cinemastreaming.png";

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  const handleCookieSettings = () => {
    if (window.openCookieSettings) {
      window.openCookieSettings();
    }
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/10">
      <div className="max-w-[1920px] mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Logo & Description */}
          <div>
            <div className="mb-4">
              <img 
                src={LOGO_URL} 
                alt="Bravo Cinemastreaming" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-white/60 text-sm mb-6">
              Plataforma de contratación by Versión Digital
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              {[Facebook, Twitter, Instagram, Youtube].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-[#e4002b] hover:bg-[#e4002b] transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/aviso-legal" 
                  onClick={handleLinkClick}
                  className="text-white/60 text-sm hover:text-[#e4002b] transition-colors"
                >
                  Aviso Legal
                </Link>
              </li>
              <li>
                <Link 
                  to="/politica-privacidad" 
                  onClick={handleLinkClick}
                  className="text-white/60 text-sm hover:text-[#e4002b] transition-colors"
                >
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link 
                  to="/politica-cookies" 
                  onClick={handleLinkClick}
                  className="text-white/60 text-sm hover:text-[#e4002b] transition-colors"
                >
                  Política de Cookies
                </Link>
              </li>
              <li>
                <button 
                  onClick={handleCookieSettings}
                  className="flex items-center gap-2 text-white/60 text-sm hover:text-[#e4002b] transition-colors"
                >
                  <Cookie className="w-3.5 h-3.5" />
                  Configurar Cookies
                </button>
              </li>
              <li>
                <Link 
                  to="/condiciones" 
                  onClick={handleLinkClick}
                  className="text-white/60 text-sm hover:text-[#e4002b] transition-colors"
                >
                  Condiciones de Contratación
                </Link>
              </li>
            </ul>
          </div>

          {/* Administración */}
          <div>
            <h3 className="text-white font-semibold mb-4">Administración</h3>
            <Link 
              to="/admin/login" 
              onClick={handleLinkClick}
              className="flex items-center gap-2 text-white/60 text-sm hover:text-[#e4002b] transition-colors"
            >
              <Shield className="w-4 h-4" />
              Panel de admin
            </Link>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-white font-semibold mb-4">Mantente informado</h3>
            <p className="text-white/60 text-sm mb-4">
              Suscríbete a nuestro boletín para las últimas actualizaciones y contenido exclusivo.
            </p>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
              <input
                type="email"
                placeholder="Tu email"
                className="w-full pl-10 pr-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white text-sm placeholder:text-white/40 focus:outline-none focus:border-[#e4002b] transition-colors"
              />
            </div>
            <button className="w-full mt-3 py-2.5 bg-[#e4002b] text-white text-sm font-medium rounded-lg hover:bg-[#c70024] transition-colors">
              Suscribirse
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Bravo Cinemastreaming. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link 
              to="/aviso-legal" 
              onClick={handleLinkClick}
              className="text-white/40 text-sm hover:text-white transition-colors"
            >
              Aviso Legal
            </Link>
            <Link 
              to="/politica-cookies" 
              onClick={handleLinkClick}
              className="text-white/40 text-sm hover:text-white transition-colors"
            >
              Política de Cookies
            </Link>
            <Link 
              to="/politica-privacidad" 
              onClick={handleLinkClick}
              className="text-white/40 text-sm hover:text-white transition-colors"
            >
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
